module.exports = __webpack_public_path__ + "img/logo.394a44f5.png";